/**
 * 首页相关埋点
 * 文档：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/Jw3ESeeIzA/4XuPPLXhOWTIjP
*/

import {COMMON_USE_KNOWLEDGE_TYPE} from '@/constants/home';
import {feLogger, getSource, repType} from '.';
import reportIds from './reportIds';
import {IPosition} from '@/interface';
import {HomePageTabMenu} from '@/Constant';
type IKnowledgeType = typeof COMMON_USE_KNOWLEDGE_TYPE[keyof typeof COMMON_USE_KNOWLEDGE_TYPE] | undefined;

const logger = (repId: string, type: string, params?: any) => {
    try {
        const data = {
            rep_id: repId,
            rep_type: type,
            rep_params: params,
        };
        if (!params) {
            delete data.rep_params;
        }
        feLogger(data);
    } catch (e) {
        console.error(e);
    }
};

export const openHomePageLog = () => {
    logger(reportIds.homeOpen, repType.Click);
};

// 点击知识币icon
export const knowledgeCurrencyClick = () => {
    return logger(reportIds.clickIconRecords, repType.Click);
};

// 文档置顶时埋点
export const toppingRecordsClick = () => {
    return logger(reportIds.toppingRecords, repType.Click);
};
// 取消置顶时候埋点
export const cancelToppingClick = () => {
    return logger(reportIds.cancelToppingRecords, repType.Click);
};
export const clickQuickContentLog = (type: IKnowledgeType) => {
    return logger(reportIds.homeQuickClick, repType.Click, {
        type,
    });
};

export const showFindTabReminderBubble = () => {
    return logger(reportIds.showFindTabReminderBubble, repType.Show);
};
export const clickFindTabReminderBubble = () => {
    return logger(reportIds.clickFindTabReminderBubble, repType.Click);
};
export const closeFindTabReminderBubble = () => {
    return logger(reportIds.closeFindTabReminderBubble, repType.Click);
};

export const clickQuickAddLog = () => {
    return logger(reportIds.homeQuickAddClick, repType.Click);
};

export const logQuickAddResultLog = (isSuccess: boolean, type: IKnowledgeType) => {
    return logger(reportIds.homeQuickAddResult, repType.Click, {
        status: isSuccess ? 1 : 2,
        type,
    });
};

export const findPageContentSourceRecommendLog = (source:string[]) => {
    return logger(reportIds.findPageContentSourceRecommend, repType.Show, {
        source,
    });
};
export const findPageContentSourceHotKnowledgeLog = (source:number[]) => {
    return logger(reportIds.findPageContentSourceHotKnowledge, repType.Show, {
        source,
    });
};
export const findPageContentSourceHighValueLog = (
    params : {DID:string, source:string, rank:string}
) => {
    return logger(reportIds.findPageContentSourceHighValuePage, repType.Show, params);
};

export const homeTableClickItemLog = (
    position: IPosition,
    sort: number
) => {
    return logger(reportIds.homeTableClickItem, repType.Click, {
        position,
        sort,
    });
};

export const homeTableOperationLog = (
    position: IPosition,
    action: string
) => {
    return logger(reportIds.homeTableOperation, repType.Click, {
        position,
        action,
    });
};

export const homeTableFilterLog = (position: IPosition) => {
    return logger(reportIds.homeTableFilter, repType.Click, {
        position,
    });
};

export const homeTableFilterMenuLog = (position: HomePageTabMenu) => {
    return logger(reportIds.homeTableFilterMenu, repType.Click, {
        position,
    });
};

export const homeSidbarClickToMyRepositoryLog = () => {
    return logger(reportIds.homeSidbarClickToMyRepository, repType.Click);
};

export const homeSidbarClickToMyDepartmentLog = () => {
    return logger(reportIds.homeSidbarClickToMyDepartment, repType.Click);
};
// 热榜点击
export const homeSidbarClickHotDocumentLog = (sort: number, docGuid: string) => {
    return logger(reportIds.homeSidbarClickHotDocument, repType.Click, {
        sort,
        docGuid,
    });
};
// 热榜展现
export const homeSidbarHotListShowLog = (showNum: number, list: string[]) => {
    return logger(reportIds.homeSidbarHotList, repType.Show, {
        showNum,
        list,
    });
};
// 重点文档展现
export const homeSidbarImportantDocListShowLog = (docList: string[], lableList: string[]) => {
    return logger(reportIds.homeSidbarImportantDocShowList, repType.Show, {
        docList,
        lableList,
    });
};
// 热榜点击
export const homeSidbarClickImportantDocLog = (doc: string, lable: string) => {
    return logger(reportIds.homeSidbarClickImportantDoc, repType.Click, {
        doc,
        lable,
    });
};
// 热榜更多点击
export const homeSidbarClickImportantDocMoreLog = (userGuid?: string) => {
    return logger(reportIds.homeSidbarClickImportantDocMore, repType.Click, {
        userGuid,
    });
};
export const clickToDepartmentManageLog = () => {
    return logger(reportIds.homeClickToDepartmentManage, repType.Click, {});
};
// 我关注的tab里取消关注
export const cancelAttentionLog = () => {
    return logger(reportIds.cancelAttentionId, repType.Click, {});
};

// 当在知识库首页点击个人成就数据（进入个人主页界面）
export const clickAchievementToPersonalPageLog = () => {
    return logger(reportIds.clickAchievementToPersonalPage, repType.Click, {});
};

// 知识库首页banner点击时
export const clickHomeBannerLog = () => {
    return logger(reportIds.clickHomeBannerLog, repType.Click, {});
};

// 当在知识库任何界面，点面右上角的头像（进入个人主页界面）时
export const clickAvatarToPersonalPage = () => {
    return logger(reportIds.clickAvatarToPersonalPage, repType.Click, {});
};

// 当在知识库任何界面，点击右上角的头像下拉菜单个人主页选项（进入个人主页界面）时
export const clickAvatarDropMenuToPersonalPage = () => {
    return logger(reportIds.personOpenFromTop, repType.Click, {});
};

// 当个人主页界面被展现时，上报打点
export const personalPageOnLoad = () => {
    return logger(reportIds.personalPageOnLoad, repType.Show, {source: getSource()});
};

// 更换背景图成功
export const personalPageChangeBackgroundPageSuccess = () => {
    return logger(reportIds.personalPageChangeBackgroundPageSuccess, repType.Click, {});
};

// 切换每日一句成功
export const personalPageChangeSentenceSuccess = () => {
    return logger(reportIds.personalPageChangeSentenceSuccess, repType.Click, {});
};

// 显示功能未解锁弹窗
export const personalPageIsUnLockDialogShow = () => {
    return logger(reportIds.personalPageIsUnLockDialogShow, repType.Show, {});
};

// 在功能未解锁弹窗上点击「去使用知识星」
export const personalPageIsUnLockDialogClickKnowledgeCoin = () => {
    return logger(reportIds.personalPageIsUnLockDialogClickKnowledgeCoin, repType.Click, {});
};


// 点击个人知识库按钮
export const personalPageClickPersonalKu = () => {
    return logger(reportIds.personalPageClickPersonalKu, repType.Click, {});
};

// 展示知识币规则介绍界面
export const personalPageKnowledgeCoinRulesOnLoad = () => {
    return logger(reportIds.personalPageKnowledgeCoinRulesOnLoad, repType.Show, {});
};

// 展示本周可用知识币明细窗口
export const personalPageKnowledgeCoinDetailsOnLoad = () => {
    return logger(reportIds.personalPageKnowledgeCoinDetailsOnLoad, repType.Show, {});
};

// 展示获赠知识币明细窗口
export const personalPageKnowledgeCoinBeSentOnLoad = () => {
    return logger(reportIds.personalPageKnowledgeCoinBeSentOnLoad, repType.Show, {});
};
// 展示获赞明细窗口
export const personalPageKnowledLikeListBeSentOnLoad = () => {
    return logger(reportIds.personalPageKnowledLikeListBeSentOnLoad, repType.Show, {});
};

// 点击公开发布的文档
export const personalPageClickOpenDoc = () => {
    return logger(reportIds.personalPageClickOpenDoc, repType.Click, {});
};
// 点击公开发布的tab菜单
export const personalPageClickPublishTab = () => {
    return logger(reportIds.personalPageClickPublishTab, repType.Click, {});
};
// 点击我获币及获赞的文档
export const personalPageClickOpenGainCoinAndLikeDoc = () => {
    return logger(reportIds.personalPageClickOpenGainCoinAndLikeDoc, repType.Click, {});
};
// 点击我获币及获赞的tab菜单
export const personalPageClickGainCoinAndLikeTab = () => {
    return logger(reportIds.personalPageClickGainCoinAndLikeTab, repType.Click, {});
};
// 点击我送币的文档
export const personalPageClickOpenSendCoinDoc = () => {
    return logger(reportIds.personalPageClickOpenSendCoinDoc, repType.Click, {});
};
// 点击我送币的tab菜单
export const personalPageClickSendCoinTab = () => {
    return logger(reportIds.personalPageClickSendCoinTab, repType.Click, {});
};

// 关闭【我获币及获赞列表】可见性
export const personalPageCloseGainCoinAndLikeVisible = () => {
    return logger(reportIds.personalPageCloseGainCoinAndLikeVisible, repType.Click, {});
};

// 关闭【我送币文档列表】可见性
export const personalPageCloseSendCoinVisible = () => {
    return logger(reportIds.personalPageCloseSendCoinVisible, repType.Click, {});
};

// 在【我获币及获赞】列表点击公开发布菜单
export const personalPageGainCoinAndLikeListPublish = () => {
    return logger(reportIds.personalPageGainCoinAndLikeListPublish, repType.Click, {});
};

// 在【我获币及获赞】列表公开发布文档成功
export const personalPageGainCoinAndLikeListPublishSuccess = () => {
    return logger(reportIds.personalPageGainCoinAndLikeListPublishSuccess, repType.Click, {});
};

// 点击公开发布文档关联的知识库
export const personalPageClickOpenDocInKu = () => {
    return logger(reportIds.personalPageClickOpenDocInKu, repType.Click, {});
};

// 展示全部动态通知界面
export const personalPageNotificationOnLoad = () => {
    return logger(reportIds.personalPageNotificationOnLoad, repType.Show, {});
};

// 点击动态通知
export const personalPageClickNotification = () => {
    return logger(reportIds.personalPageClickNotification, repType.Click, {});
};

// 点击动态通知中的「文档」
export const personalPageClickNotificationDoc = () => {
    return logger(reportIds.personalPageClickNotificationDoc, repType.Click, {});
};

// 赠送知识币成功
export const personalPageKnowledgeCoinSendSuccess = (
    pageId: string,
    kbId: string,
    kbOrgId: string,
    // 用户id
    uId: string,
    // 用户名称
    name: string | null,
    // 是否有夸赞 0没有 1有
    msg: string,
    // 夸赞类型 0:没有自定义内容、全是快捷评论 1:有自定义内容
    msgType: string
) => {
    const data: any = {
        page_id: pageId,
        kb_id: kbId,
        kb_org_id: kbOrgId,
        source: getSource(),
        UID: uId,
        name: name,
        Msg: msg,
    };
    if (msg === '1') {
        data.Msg_type = msgType;
    }
    return logger(reportIds.personalPageKnowledgeCoinSendSuccess, repType.Click, data);
};

// 展示知识币新手引导气泡
export const personalPageShownKnowledgeCoinGuide = () => {
    return logger(reportIds.personalPageShownKnowledgeCoinGuide, repType.Show, {});
};

// 展示知识币新手引导气泡
export const personalPageGiveCoinDocClick = () => {
    return logger(reportIds.personalPageGiveCoinDocClick, repType.Click, {});
};

// 展示知识币新手引导气泡
export const personalPageGiveCoinChange = () => {
    return logger(reportIds.personalPageGiveCoinChange, repType.Click, {});
};


// 点击「发布到个人主页」按钮时上报打点
export const docPublishToPersonalPage = () => {
    return logger(reportIds.docPublishToPersonalPage, repType.Click, {});
};
// 在「确定发布页面」弹窗点击【公开】按钮时，上报打点
export const docPublishToPersonalPageConfirm = () => {
    return logger(reportIds.docPublishToPersonalPageConfirm, repType.Click, {});
};
// 在「确定取消发布页面」弹窗点击【确定】按钮时，上报打点
export const docCancelPublishToPersonalPageConfirm = () => {
    return logger(reportIds.docCancelPublishToPersonalPageConfirm, repType.Click, {});
};


// 新建星标分组成功
export const createStarGroupSuccessLog = () => {
    return logger(reportIds.createStarGroupSuccess, repType.Click, {});
};
// 为星标的内容绑定分组
export const starBindGroupSuccessLog = () => {
    return logger(reportIds.starBindGroupSuccess, repType.Click, {});
};
// 星标改名成功
export const starGroupRenameSuccessLog = () => {
    return logger(reportIds.starGroupRenameSuccess, repType.Click, {});
};

export const openPersonalReportLog = () => {
    return logger(reportIds.openPersonalReport, repType.Click, {});
};
// 打开知识币勋章弹窗
export const openAchieveDialogBuried = () => {
    return logger(reportIds.openAchieveDialog, repType.Click, {});
};
// 知识币勋章弹窗中切换等级
export const changeAchieveLevelBuried = () => {
    return logger(reportIds.changeAchieveLevel, repType.Click, {});
};

// 个人主页公开发布按钮弹窗
export const clickPersonalPagePublishBtn = () => {
    return logger(reportIds.clickPersonalPagePublishBtn, repType.Click, {});
};
export const showPersonalPagePublishDialog = () => {
    return logger(reportIds.showPersonalPagePublishDialog, repType.Click, {});
};
export const confirmPersonalPagePublishDialog = () => {
    return logger(reportIds.confirmPersonalPagePublishDialog, repType.Click, {});
};
export const personalPageEnterExchangeEasyCoin = () => {
    return logger(reportIds.personalPageEnterExchangeEasyCoin, repType.Show, {});
};
export const personalPageEnterExchangeEasyCoinRuleModal = () => {
    return logger(reportIds.personalPageEnterExchangeEasyCoinRuleModal, repType.Show, {});
};
export const personalPageExchangeEasyCoinSuccess = (
    params: {konwleageCoinAmount: number, easyCoinAmount: number}
) => {
    return logger(reportIds.personalPageExchangeEasyCoinSuccess, repType.Click, params);
};
export const clickSetPersenalShowRepoEntryToAllBuried = () => {
    return logger(reportIds.persenalShowRepoEntryToAllBuried, repType.Click, {});
};
export const clickSetPersenalShowRepoEntryToSelfBuried = () => {
    return logger(reportIds.persenalShowRepoEntryToSelfBuried, repType.Click, {});
};

// 知识库首页点击高价值知识榜单内容
export const clickHeaderFindPage = () => {
    return logger(reportIds.findPageClick, repType.Click, {});
};

// 发现页面
export const showFindPage = () => {
    return logger(reportIds.findPageShow, repType.Click, {});
};

// 知识库首页点击高价值知识榜单内容
export const clickHomeHighValueList = () => {
    return logger(reportIds.homeHighValueList, repType.Click, {});
};
// 知识库首页点击高价值知识榜的发现更多
export const clickHomeHighValueMore = () => {
    return logger(reportIds.homeHighValueMore, repType.Click, {});
};
// 个人主页「给好文投币」模块点击发现更多
export const clickGiveCoinTextMore = () => {
    return logger(reportIds.giveCoinTextMore, repType.Click, {});
};
// 发现页面点击公开好文推荐Tab
export const clickFindPageTabRecommend = () => {
    return logger(reportIds.findPageTabRecommend, repType.Click, {});
};
// 发现页面点击公开好文推荐列表
export const clickFindPageRecommendList = (
    params: {source: string}
) => {
    return logger(reportIds.findPageRecommendList, repType.Click, params);
};
// 发现页面点击高价值榜单Tab
export const clickFindPageTabList = () => {
    return logger(reportIds.findPageTabList, repType.Click, {});
};
// 发现页面点击高价值榜单列表
export const clickFindPageList = (
    params: {DID: string, source:string, rank: string}
) => {
    return logger(reportIds.findPageList, repType.Click, params);
};
// 发现页面公开好文推荐，点击查看完整榜单
export const clickFindPageCompleteList = () => {
    return logger(reportIds.findPageCompleteList, repType.Click, {});
};
// 展示知识币过期提示条
export const usableCoinExpriedRemindTip = () => {
    return logger(reportIds.usableCoinExpriedRemindTip, repType.Show, {});
};
// 在知识币过期提示条点击「去投币」
export const usableCoinExpriedRemindTipToGoGiveCoin = () => {
    return logger(reportIds.usableCoinExpriedRemindTipToGoGiveCoin, repType.Click, {});
};
// 「所属部门」下方点击获币用户头像
export const homeDepartmentGainCoinUserAvatar = () => {
    return logger(reportIds.homeDepartmentGainCoinUserAvatar, repType.Click, {});
};
// 文档页面投币点击发现更多好文
export const clickGiveCoinTextMoreGiveCoin = () => {
    return logger(reportIds.findMoreGoodArticle, repType.Click, {});
};
// 兑换简单币页面点击活动奖励知识币详情
export const clickActiveCoinDetail = () => {
    return logger(reportIds.exchangeEasyCoinPageActiveCoinDetail, repType.Click, {});
};

/* 知识币盲盒 */
// （PC）投币成功窗口显示盲盒时，上报埋点
export const showMysteryBoxDialog = () => {
    return logger(reportIds.showMysteryBoxDialog, repType.Click, {});
};

// （PC）在投币出盲盒弹窗打开盲盒成功时，上报埋点记录用户ID
export const openMysteryBoxSuccess = () => {
    return logger(reportIds.openMysteryBoxSuccess, repType.Click, {});
};

// （PC）在投币出盲盒弹窗点击关闭时，上报埋点
export const closeMysteryBoxDialog = () => {
    return logger(reportIds.closeMysteryBoxDialog, repType.Click, {});
};

// 个人主页点击【我的盲盒奖励】菜单时，上报埋点
export const clickMyMysteryBoxHistory = () => {
    return logger(reportIds.clickMyMysteryBoxHistory, repType.Click, {});
};
// 展示【我的盲盒奖励】窗口时，上报埋点
export const showMysteryBoxHistory = () => {
    return logger(reportIds.showMysteryBoxHistory, repType.Click, {});
};
// 展现奖品详情窗口时，上报埋点
export const showMysteryBoxDetail = () => {
    return logger(reportIds.showMysteryBoxDetail, repType.Click, {});
};
// 在奖品详情窗口点击【查看我的可兑换知识币】时，上报埋点
export const clickMyCoinFromMysteryBox = () => {
    return logger(reportIds.clickMyCoinFromMysteryBox, repType.Click, {});
};
// 在盲盒奖品详情窗口点击文档时，上报埋点
export const clickMysteryBoxDetailDoc = () => {
    return logger(reportIds.clickMysteryBoxDetailDoc, repType.Click, {});
};
// 发现页面热点知识榜点击
export const clickFindPageHotList = (params: {source: string}) => {
    return logger(reportIds.findPageHotList, repType.Click, params);
};

// 点击文档tab埋点
export const personalPageLikeTab = () => {
    return logger(reportIds.personalPageLikeTab, repType.Click, {});
};

// 点击我点赞 tab列表的文档
export const personalPageLikeDoc = () => {
    return logger(reportIds.personalPageLikeDoc, repType.Click, {});
};

// 在我点赞 tab列表取消点赞成功
export const personalPageCancelLikeSuccess = () => {
    return logger(reportIds.personalPageCancelLikeSuccess, repType.Click, {});
};

export const headClickTopListTabLog = () => {
    return logger(reportIds.headClickTopListTab, repType.Click, {});
};

export const showTopListPageLog = () => {
    return logger(reportIds.showTopListPage, repType.Show, {});
};

export const findPageClickAroundPeopleLog = () => {
    return logger(reportIds.findPageClickAroundPeople, repType.Click, {});
};

// 权限申请时切换为非推荐管理员
export const applyWithNoRecommend = () => {
    return logger(reportIds.applyWithNoRecommend, repType.Click, {});
};

// 发现-榜单 知识达人周榜模块 曝光
export const showKnowledgeeWeekLog = () => {
    return logger(reportIds.showKnowledgeeWeek, repType.Show, {});
};

// 发现-榜单 知识达人周榜模块 点击
export const clickKnowledgeeWeekLog = () => {
    return logger(reportIds.clickKnowledgeeWeek, repType.Click, {});
};
// 个人主页显示发布文档的提醒气泡
export const showHomePublicGuideShow = () => {
    return logger(reportIds.showHomePublicGuideShow, repType.Show, {});
};
// 个人主页点击发布文档的提醒气泡
export const clickHomePublicGuideShow = () => {
    return logger(reportIds.clickHomePublicGuideShow, repType.Click, {});
};
// 在「发布文档」弹窗勾选推荐文档并点击发布
export const clickPublicButton = (params: {num: string}) => {
    return logger(reportIds.clickPublicButton, repType.Click, params);
};
// 在「发布文档」弹窗点击换一批
export const clickPublicReloadButton = () => {
    return logger(reportIds.clickPublicReloadButton, repType.Click, {});
};


// 用户有查看权限，进行”申请可编辑“权限
export const clickApplyEditPermission = () => {
    return logger(reportIds.applyEditPermission, repType.Click, {});
};

// 用户有查看权限， 进行“申请页面管理员”权限
export const clickApplyAdminPermission = () => {
    return logger(reportIds.applyAdminPermission, repType.Click, {});
};

// 用户有编辑权限，进行“申请页面管理员” 权限
export const clickEditAdminPermission = () => {
    return logger(reportIds.editAdminPermission, repType.Click, {});
};
